import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, SplitText);



function gsap_introHome(){
    const wrapper = document.querySelector('#intro-home');
    const tl = gsap.timeline();

    if (wrapper) {
        const title = wrapper.querySelector('h1');
        const subtitle = wrapper.querySelector('p'); 
        const cta = wrapper.querySelector('.cta'); 

        if (!title || !subtitle || !cta) return;

        gsap.set([title, subtitle, cta], { autoAlpha: 1 }); 

        let textLines = new SplitText(title, { type: "lines" });
        let textWords = new SplitText(subtitle, { type: "words" })

        tl.from(textLines.lines, { opacity: 0, ease: "back", stagger: 0.2 }, 1)
        tl.from(textWords.words, { opacity: 0, y: 50, ease: "back(0.1)", stagger: 0.05 }, '<1')

        tl.from(cta, {opacity: 0, y: 20})

    }
}
window.addEventListener('DOMContentLoaded', gsap_introHome);




function gsap_mediaText(){
    const wrappers = document.querySelectorAll('.gs--mediaText');

    if (!wrappers) return;

    wrappers.forEach(el => {
        const text = el.querySelectorAll('p');
        const img = el.querySelectorAll('img');

        if (text.length === 0 || img.length === 0) return;

        gsap.set([text, img], { autoAlpha: 1 }); 

        const tl = gsap.timeline();

        tl.from(text, {
            opacity: 0,
            y: 32,
            stagger: 0.35
        });

        tl.to(img, {
            opacity: 1,
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
            y: 0,
            duration: 2,
            ease: "back.out"
        }, "<0.3");

        ScrollTrigger.create({
            trigger: el,
            start: "top 75%",
            animation: tl
        });
    });
}
window.addEventListener('DOMContentLoaded', gsap_mediaText);






function gsap_changeToBgSecondaryOnScroll(){

    const section = document.querySelector('#gs--changeToBgSecondaryOnScroll');

    if (!section) return;

    gsap.set(section,{backgroundColor: '#FFFFFF'});
    const text = section.querySelector('h2');

    const tl = gsap.timeline({
        paused: true, 
        defaults: { 
            duration: 0.4, 
            ease: 'power1.out' 
        },
        scrollTrigger: {
            trigger: section,
            start: 'top 70%',
            end: 'bottom 30%',
            // markers: true,
            toggleActions: 'play reverse play reverse'
        }
    });

    tl.to(section, {
        backgroundColor: '#031055' 
    }, 0);

    if (text) tl.to(text, { color: '#fff' }, 0);
    
}
window.addEventListener('DOMContentLoaded', gsap_changeToBgSecondaryOnScroll);


function gsap_changeToBgLightOnScroll(){

    const section = document.querySelector('#gs--changeToBgLightOnScroll');

    if (!section) return;

    gsap.set(section,{backgroundColor: '#FFFFFF'});
    const text = section.querySelector('h2');

    const tl = gsap.timeline({
        paused: true, 
        defaults: { 
            duration: 0.4, 
            ease: 'power1.out' 
        },
        scrollTrigger: {
            trigger: section,
            start: 'top 70%',
            end: 'bottom 30%',
            // markers: true,
            toggleActions: 'play reverse play reverse'
        }
    });

    tl.to(section, {
        backgroundColor: '#ECECEC'
    }, 0);

    if (text) tl.to(text, { color: '#031055' }, 0);
    
}
window.addEventListener('DOMContentLoaded', gsap_changeToBgLightOnScroll);



function gsap_entryHero(){
    const sections = document.querySelectorAll('.hst-block');

    if (sections.length === 0) return;

    sections.forEach((section) => {
        const title = section.querySelector(".gs--title");
        const overtitle = section.querySelector(".gs--overtitle");
        const desc = section.querySelector(".gs--desc");
        const btn = section.querySelector(".gs--btn");

        if(!title) return;

        gsap.set([title, overtitle, desc, btn], { autoAlpha: 1 }); 

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'top 80%',
            }
        });

        let textLines = new SplitText(title, { type: "lines" });

        tl.from(textLines.lines, { y:25, opacity: 0, duration: 0.75, stagger: 0.1 }, "<0.15")
        if (overtitle) tl.from(overtitle, { y:20, opacity: 0, duration: 1}, "<")
    

        if (desc) tl.from(desc, { y:10, opacity: 0, duration: 1 })
        if (btn) tl.from(btn, { y:20, opacity: 0, duration: 1 })

    });
};
window.addEventListener('load', gsap_entryHero);



function gsap_general_animation(){
    
    ScrollTrigger.batch(".gs--textWords", {
        start: "top 80%",
        onEnter: (element, triggers) => {
            let textWords = new SplitText(element, { type: "words" })
            gsap.from(textWords.words, { opacity: 0, y: 50, ease: "back(0.1)", stagger: 0.15 })
        },
    });


    ScrollTrigger.batch(".gs--fadeInFromUp", {
        start: "top 80%",
        onEnter: (element, triggers) => {
            gsap.set(element, { autoAlpha: 1 }); 
            gsap.from(element, {opacity: 0, stagger: 0.25, y: 30});
        },
    });

//     ScrollTrigger.batch(".gs--fadeInFromDown", {
//         start: "top 90%",
//         onEnter: (elements, triggers) => {
//             gsap.to(elements, {opacity: 1, stagger: 0.25, y: 0, duration: 0.75 });
//         },
//     });


//     ScrollTrigger.batch(".gs--fadeInFromRight", {
//         start: "top 90%",
//         onEnter: (elements, triggers) => {
//             gsap.to(elements, {opacity: 1, stagger: 0.25, x: 0, duration: 0.75 });
//         },
//     });

//     ScrollTrigger.batch(".gs--fadeInFromLeft", {
//         start: "top 90%",
//         onEnter: (elements, triggers) => {
//             gsap.to(elements, {opacity: 1, stagger: 0.25, x: 0, duration: 0.75 });
//         },
//     });

//     ScrollTrigger.batch(".gs--fadeInDiagonalFromLeft", {
//         start: "top 90%",
//         onEnter: (elements, triggers) => {
//             gsap.to(elements, {opacity: 1, stagger: 0.25, x: 0, y: 0, duration: 0.75 });
//         },
//     });

//     ScrollTrigger.batch(".gs--fadeInDiagonalFromRight", {
//         start: "top 90%",
//         onEnter: (elements, triggers) => {
//             gsap.to(elements, {opacity: 1, stagger: 0.25, x: 0, y: 0, duration: 0.75 });
//         },
//     });
    

//     ScrollTrigger.batch(".gs--maskUp", {
//         start: "top 90%",
//         onEnter: (elements, triggers) => {
//             gsap.to(elements, {clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)", y: 0, duration: 1, scrub: true });
//         },
//     });

//     ScrollTrigger.batch(".gs--fadeInToOpacity", {
//         start: "top 70%",
//         onEnter: (elements, triggers) => {
//             gsap.to(elements, {opacity: 1, duration: 0.5, y: 0, scrub: true });
//         },
//     });
    
}
gsap_general_animation();
